var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconawesomeStopCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21.999,
    viewBox: "0 0 22 21.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-stop-circle",
    "data-name": "Icon awesome-stop-circle",
    d: "M11.563.563a11,11,0,1,0,11,11A11,11,0,0,0,11.563.563ZM15.821,15.11a.712.712,0,0,1-.71.71h-7.1a.712.712,0,0,1-.71-.71v-7.1a.712.712,0,0,1,.71-.71h7.1a.712.712,0,0,1,.71.71Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#ff7d00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeStopCircle);
export default __webpack_public_path__ + "static/media/Icon awesome-stop-circle.6b54ea666819a4e1ddcd390ff194c2a5.svg";
export { ForwardRef as ReactComponent };